import { gql } from "@apollo/client";

export const CreateServiceReminder = gql`
    mutation CreateServiceReminder ($installedBaseNodeId: ID!, $input: ServiceReminderInput!) {
        createServiceReminder (installedBaseNodeId: $installedBaseNodeId, input: $input) {
            id
            serviceTaskTypeKey
            nextDueDate
        }
    }
`;
